import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileUnderReviewCard from './ProfileUnderReviewCard';

const ProfileUnderReview = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      navigate('/signin');
    }
  }, [navigate]);

  return (
    <div
      className="flex min-h-screen items-center justify-center p-4 pb-16"
      style={{
        background: 'linear-gradient(to bottom right, #e3f2fd, #bbdefb)',
      }}
    >
      <ProfileUnderReviewCard />
    </div>
  );
};

export default ProfileUnderReview;
